import {UserTariffCountKey} from './IUser';

import useIsTariffFeatureUnavailable from './useIsTariffFeatureUnavailable';

export type PlugState = 'noAccess' | 'empty' | 'notFound' | null;

interface UsePlugStateParams {
    tariffField: UserTariffCountKey;
    isLoading: boolean;
    isEmpty: boolean;
    hasFilters: boolean;
}

const usePlugState = ({tariffField, isLoading, isEmpty, hasFilters}: UsePlugStateParams): PlugState => {
    const isUnavailable = useIsTariffFeatureUnavailable(tariffField);

    if (isUnavailable) {
        return 'noAccess';
    }

    if (isLoading || !isEmpty) {
        return null;
    }

    return hasFilters ? 'notFound' : 'empty';
};

export default usePlugState;
